module.exports = __webpack_public_path__ + "assets/img/buyed-btn-1dca299c.png";